import { ncbClient } from './ncbClient';

export const orderService = {
  async createOrder(orderData) {
    try {
      // Create order record
      const orderResponse = await ncbClient.createOrder({
        user_id: orderData.userId,
        order_date: new Date().toISOString(),
        total_amount: orderData.total,
        status: 'pending'
      });
      
      const orderId = orderResponse.id;
      
      // Create payment record
      await ncbClient.createPayment({
        user_id: orderData.userId,
        order_id: orderId,
        payment_date: new Date().toISOString(),
        amount: orderData.total,
        payment_method: orderData.paymentMethod || 'credit_card',
        transaction_id: orderData.paymentIntentId
      });
      
      // Create shipping record
      await ncbClient.createShipping({
        order_id: orderId,
        shipping_method: 'Standard',
        tracking_number: `TRACK${Math.random().toString(36).substr(2,9).toUpperCase()}`,
        shipped_date: new Date().toISOString(),
        delivery_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString() // 7 days from now
      });
      
      return {
        id: orderId,
        orderNumber: `ORD${orderId.toString().padStart(6, '0')}`,
        userId: orderData.userId,
        total: orderData.total,
        status: 'pending',
        createdAt: new Date().toISOString(),
        items: orderData.items
      };
    } catch (error) {
      throw new Error('Failed to create order');
    }
  },

  async getOrders(userId) {
    try {
      const response = await ncbClient.readOrders({ user_id: userId });
      return response.data.map(order => ({
        id: order.order_id,
        orderNumber: `ORD${order.order_id.toString().padStart(6, '0')}`,
        userId: order.user_id,
        total: order.total_amount,
        status: order.status,
        createdAt: order.order_date,
        items: [] // Would need to join with order items table
      }));
    } catch (error) {
      throw new Error('Failed to fetch orders');
    }
  },

  async getOrder(id) {
    try {
      const response = await ncbClient.readOrder(id);
      const order = response.data;
      return {
        id: order.order_id,
        orderNumber: `ORD${order.order_id.toString().padStart(6, '0')}`,
        userId: order.user_id,
        total: order.total_amount,
        status: order.status,
        createdAt: order.order_date,
        items: []
      };
    } catch (error) {
      throw new Error('Failed to fetch order');
    }
  },

  async updateOrderStatus(id, status) {
    try {
      const response = await ncbClient.updateOrder(id, { status: status });
      return response;
    } catch (error) {
      throw new Error('Failed to update order status');
    }
  },
};